import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { UserContext } from '~/components/providers/UserProvider';
import { useLocationKey } from '~/hooks/useLocationKey';
import { PUSHER_SEARCH_ENDPOINT } from '~/domains/pusher/constants';
import { usePusherFetch } from '~/domains/pusher/hooks/usePusherFetch';
import type { GetContestsPayload } from '~/services/contests/contests.service.api';
import { getContests } from '~/services/contests/contests.service.api';
import type { Contest } from '~/domains/contest/domains/services/interfaces/contest.interface';

type UseContestsOptions = {
  enabled?: boolean;
  keepPreviousData?: boolean;
};

export const useContests = (payload: GetContestsPayload, queryOpts: UseContestsOptions = {}) => {
  const { user } = useContext(UserContext);
  const { locationKey } = useLocationKey();
  const { fetchRows, isReady: isPusherReady } = usePusherFetch<Contest>({
    endpoint: PUSHER_SEARCH_ENDPOINT,
  });

  // eslint-disable-next-line local-rules/require-query-stale-time
  return useQuery({
    // Using stable locationKey to prevent unnecessary refetches
    queryKey: ['contests', payload, user?.id, locationKey, payload.filter?.contestIds?.join(',')],
    queryFn: () => fetchRows((headers) => getContests(payload, headers)),
    ...queryOpts,
    keepPreviousData: queryOpts.keepPreviousData ?? true,
    enabled: (queryOpts.enabled ?? true) && isPusherReady,
  });
};
